import {
  useEffect,
  useRef,
  useState
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  useNavigate,
  useSearchParams
} from 'react-router-dom'
import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  IconButton,
  Stack,
  Text,
  useDisclosure,
  useOutsideClick
} from '@chakra-ui/react'
import { ArrowIcon } from 'assets/icons'
import {
  authSelectors,
  deleteProfileItem,
  getComments,
  getNotificationMessage,
  getPosts,
  handleOpenModal,
  markersSelectors,
  setBlogParent,
  setComments,
  setEngagementItems,
  setHideNotification,
  setNotificationSectionPage,
  setOpenFriendRequest,
  setPosts,
  setProfileItemId,
  setSavedEvents,
  setSelectedEngagementType,
  stopMap,
  usersSelectors
} from 'store'
import { clearXmppPushNotification } from 'store/chat/slice'
import {
  MODAL_SECTION,
  NotificationSections,
  PENDING,
  REJECTED,
  SUCCEEDED
} from 'utils/constants'
import {
  isAuth,
  showCoordParams
} from 'utils/helpers'
import { motion } from 'framer-motion'
import { COLORS } from 'utils/styles'

import { Notifications } from 'components/Notifications'
import { NotifBarDisplay } from 'components/Footer/NotifBarDisplay'
import { GuestNotification } from './GuestNotifications'

const MotionDrawerContent = motion(DrawerContent)

/* eslint-disable */
export const Footer = () => {
  const {
    blogParent,
    closeAllDrawers,
    getAdminNotificationsStatus,
    getCommentsStatus,
    hideDrawerAnimation,
    hideNotification,
    notificationSectionPage,
    notificationSectionPageTitle
  } = useSelector(usersSelectors)
  const {
    mapStop,
    selectedMarkerData
  } = useSelector(markersSelectors)
  const { signInStatus } = useSelector(authSelectors)

  const { onOpen, isOpen, onClose } = useDisclosure()

  const dispatch = useDispatch()
  const btnRef = useRef()
  const footerRef = useRef()
  const navigate = useNavigate()
  let touchStart, touchEnd

  const [dynamicIsOpen, setDynamicIsOpen] = useState(false)
  const [runHidePanel, setRunHidePanel] = useState(false)
  const [hidePanelAnimation, setHidePanelAnimation] = useState(false)
  const [runClosingAnimation, setRunClosingAnimation] = useState(false)
  const [localHidePanel, setLocalHidePanel] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()

  if (localStorage.getItem('is-notif-modal-open') === null) {
    localStorage.setItem('is-notif-modal-open', 'false')
  }
  
  useEffect(() => {
    const id = sessionStorage.getItem('id')

    if (id !== null) {
      setDynamicIsOpen(false)

      sessionStorage.removeItem('id')
    }
  }, [])

  const clearOptions = (isNotifModalOpen) => {
    if (isNotifModalOpen) {
      // If the marker popup is opened via the url,
      // this will ensure that the marker popup is closed
      // before opening the notification modal 
      document.querySelector('div.leaflet-container').click()
    } else {
      dispatch(setOpenFriendRequest(null))
    }

    sessionStorage.removeItem('id')
    localStorage.removeItem('openedNotifId')
    localStorage.setItem('is-notif-modal-open', 'false')
    dispatch(handleOpenModal({ isOpen: isNotifModalOpen, section: MODAL_SECTION?.RightSection }))
    navigate('/')

    if (isNotifModalOpen) {
      const customPopupOverlay = document.querySelector('#custom-popup-overlay')
      const customPopupOverlayEvent = document.querySelector('#custom-popup-overlay-event')
      if (customPopupOverlay) {
        customPopupOverlay.click()
      } else if (customPopupOverlayEvent) {
        customPopupOverlayEvent.click()
      }
    }

    // The timeout is used to ensure other drawers/modals are closed before opening
    // Also used for the timing of fiter items' animation to left
    dispatch(setHideNotification(false))
    setRunClosingAnimation(!isNotifModalOpen)
    setTimeout(() => {
      setLocalHidePanel(!isNotifModalOpen)
      setTimeout(() => setDynamicIsOpen(isNotifModalOpen), isNotifModalOpen ? 0 : 50)

      setTimeout(() => {
        if (!isNotifModalOpen && document.querySelectorAll('.chakra-modal__content').length === 0) {
          showCoordParams(setSearchParams)
        }
      }, 200)
    }
    , isNotifModalOpen ? 200 : 850)
  }

  useOutsideClick({
    ref: footerRef,
    handler: () => {
      if (sessionStorage.getItem('id') && isOpen === true) {
        dispatch(setProfileItemId(null))
        dispatch(deleteProfileItem())
        localStorage.setItem('isBlockedNotification', 'false')
        localStorage.setItem('isNotifOpen', 'false')
        sessionStorage.removeItem('id')
      }
    }
  })

  const header = () => {
    if (
      notificationSectionPage === NotificationSections.BLOG_LIST
      || notificationSectionPage === NotificationSections.BLOG_COMMENTS_FOR_POST
      || notificationSectionPage === NotificationSections.ENGAGEMENT_ITEM_LIST
      || notificationSectionPage === NotificationSections.SAVED_EVENTS_LIST
    ) {
      return `${notificationSectionPageTitle}`
    }

    if (notificationSectionPage === NotificationSections.BLOG_PREFERENCE) {
      return 'Blog'
    }

    return 'Notifications'
  }

  useEffect(() => {
    setHidePanelAnimation(true)
    setRunHidePanel(hideNotification)
    setTimeout(() => setHidePanelAnimation(false), 700)
  }, [hideNotification])

  useEffect(() => {
    if (closeAllDrawers) {
      clearOptions(false)
      onClose()
      localStorage.setItem('isBlockedNotification', 'false')
      localStorage.setItem('isNotifOpen', 'false')
    }
  }, [closeAllDrawers])

  useEffect(() => {
    if (getAdminNotificationsStatus === SUCCEEDED) {
      dispatch(clearXmppPushNotification())
    }
  }, [getAdminNotificationsStatus])

  return (
    <Stack
      position="relative"
      background={COLORS.gold}
      width="100%"
      height="50px"
      className="notificationBar"
      data-name="notificationBar"
    >
      <Box
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        cursor="pointer"
        id='open-notif-panel'
        onClick={() => {
          sessionStorage.removeItem('openProfileAfterAnimation')
          sessionStorage.removeItem('openEventAfterAnimation')

          if (
            !searchParams.get('id')
            && !searchParams.get('post-id')
            && !searchParams.get('eventid')
            && !selectedMarkerData
          ) {
            // This is to prevent profile card and chat modal being open at the same time
            document.querySelector('div.leaflet-container').click()
            dispatch(setNotificationSectionPage(NotificationSections.NOTIFICATIONS))
            dispatch(stopMap(!mapStop))
            dispatch(setBlogParent([]))
            dispatch(setPosts([]))
            dispatch(setComments([]))
            localStorage.setItem('isNotifOpen', 'true')
            clearOptions(true)
            onOpen()
          }
        }}
      >
        {
          isAuth()
            ? <NotifBarDisplay dynamicIsOpen={dynamicIsOpen} />
            : (
              <Box
                height="40px"
                padding="10px 61px"
                borderRadius="5px"
                backgroundColor="white"
                width="366px"
                fontSize="20px"
                lineHeight="22.5px"
                boxShadow="0 3px 3px 0 rgba(108, 122, 137, .7)"
                sx={{
                  '@media (max-width: 768px)': {
                    width: '385px'
                  },
                  '@media (max-width: 480px)': {
                    width: '306px',
                    fontSize: "15px"
                  },
                  '@media (max-width: 390px)': {
                    width: '266px',
                    padding: "10px 45px",
                    fontSize: "15px"
                  }
                }}
              >
                <center>
                  {
                    sessionStorage.getItem('postId')
                    && signInStatus !== SUCCEEDED
                    && !isAuth()
                      ? 'Get Connected! Sign Up...'
                      : 'Instructions'
                  }
                </center>
              </Box>
            )
        }
      </Box>

      <Drawer
        id="notification-drawer"
        isOpen={dynamicIsOpen}
        placement="right"
        onClose={() => {
          clearOptions(false)
          onClose()
          localStorage.setItem('isBlockedNotification', 'false')
          localStorage.setItem('isNotifOpen', 'false')
        }}
        finalFocusRef={btnRef}
        size="sm"
        blockScrollOnMount={false}
      >
        <MotionDrawerContent
          initial={{ x: runHidePanel || runClosingAnimation ? 0 : 500 }}
          animate={{ x: runHidePanel || runClosingAnimation ? 500 : 0 }}
          transition={{
            type: hidePanelAnimation || runClosingAnimation ? 'tween' : 'spring',
            duration: 0.8
          }}
          sx={{
            width: '95% !important'
          }}
          borderRadius="10px"
          overflow="hidden"
          marginBlock="60px"
          marginInline="10px"
          background="#c4c3c7"
          maxWidth="450px"
          opacity={hideDrawerAnimation || localHidePanel ? 0 : 1}
          ref={footerRef}
        >
          <Stack
            id="notification-drawer-header"
            spacing="43px"
            alignItems="center"
            justifyContent="space-between"
            direction="row"
            p="5px 0"
            background={COLORS.goldGradientRightToLeft}
            height="48px"
            onTouchStart={(e) => {
              touchStart = e?.targetTouches[0].clientX              
            }}
            onTouchMove={(e) => {
              touchEnd = e?.targetTouches[0].clientX
            }}
            onTouchEnd={(e) => {
              if (touchStart - touchEnd < -45) {
                clearOptions(false)
                onClose()
                dispatch(setProfileItemId(null))
                dispatch(deleteProfileItem())
                localStorage.setItem('isRequestModalOpen', 'false')
                localStorage.setItem('isBlockedNotification', 'false')
                localStorage.setItem('isNotifOpen', 'false')
                sessionStorage.removeItem('id')
              }                
            }}
          >
            <div />
            <Text
              whiteSpace="nowrap"
              fontSize="24px"
              textOverflow="ellipsis"
              overflow="hidden"
              fontWeight={600}
              paddingLeft="50px"
            >
              {header()}
            </Text>

            <IconButton
              _hover={{ background: COLORS.gold_hover }}
              background="unset"
              transform="rotate(180deg)"
              style={{
                marginRight: '5px',
                borderRadius: '5px',
                height: '40px'
              }}
              icon={<ArrowIcon />}
              onClick={() => {
                if (
                  notificationSectionPage === NotificationSections.BLOG_COMMENTS_FOR_POST
                  && blogParent.length > 1
                ) {
                  if (getCommentsStatus === PENDING) {
                    dispatch(getNotificationMessage({
                      type: REJECTED,
                      message: 'Please finish loading first before returning to previous blog post or comment',
                      isEditProfile: false
                    }))
                  } else {
                    const parentData = blogParent[blogParent.length - 1]

                    dispatch(setComments([]))
                    dispatch(getComments({
                      type: parentData.parent_type,
                      ...(parentData.parent_type === 'post' ? { post_id: parentData.post_id } : { comment_id: parentData.parent_comment_id })
                    }))

                    dispatch(setBlogParent(blogParent.slice(0, -1)))
                  }
                } else if (
                  notificationSectionPage === NotificationSections.BLOG_COMMENTS_FOR_POST
                  && blogParent.length === 1
                ) {
                  const parent = blogParent[0]
                  dispatch(setPosts([]))

                  let data = {}
                  if (parent.type === 'friends' || parent.type === 'all') {
                    data = {
                      type: parent.type
                    }
                  } else if (parent.type === 'affinity') {
                    data = {
                      type: parent.type,
                      id: blogParent[0].affinities[0].id
                    }
                  } else if (parent.type === 'profile' || parent.type === 'subscribed') {
                    data = {
                      type: parent.type,
                      id: blogParent[0].profile_id
                    }
                  }

                  dispatch(getPosts(data))
                  dispatch(setNotificationSectionPage(NotificationSections.BLOG_LIST))
                } else if (notificationSectionPage === NotificationSections.NOTIFICATIONS) {
                  clearOptions(false)
                  onClose()
                  localStorage.setItem('isBlockedNotification', 'false')
                  localStorage.setItem('isNotifOpen', 'false')
                  dispatch(setProfileItemId(null))
                } else if (notificationSectionPage === NotificationSections.ENGAGEMENT_ITEM_LIST) {
                  dispatch(setNotificationSectionPage(NotificationSections.NOTIFICATIONS))
                  dispatch(setEngagementItems([]))
                  dispatch(setSelectedEngagementType(''))
                } else if (notificationSectionPage === NotificationSections.SAVED_EVENTS_LIST) {
                  dispatch(setNotificationSectionPage(NotificationSections.NOTIFICATIONS))
                  dispatch(setSavedEvents([]))
                } else {
                  dispatch(setNotificationSectionPage(NotificationSections.NOTIFICATIONS))
                }
              }}
              id="back-button"
              outline="none"
              boxShadow="none"
              height="32px"
              borderRadius="0"
              css={{
                ':focus': {
                  outline: 'none',
                  boxShadow: 'none'
                }
              }}
            />
          </Stack>

          <DrawerBody
            sx={{
              '::MsOverflowStyle': 'none',
              '::-webkit-scrollbar': {
                display: 'none'
              }
            }}
            p="0"
          >
            {
              isAuth()
                ? <Notifications />
                : <GuestNotification />
            }
          </DrawerBody>
        </MotionDrawerContent>
      </Drawer>
    </Stack>
  )
}
